import { render, staticRenderFns } from "./Product-Specialists.vue?vue&type=template&id=3430bbb2"
import script from "./Product-Specialists.vue?vue&type=script&lang=js"
export * from "./Product-Specialists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports